import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import {scaleLinear} from 'd3-scale';
import {select} from 'd3-selection';
import {axisLeft} from 'd3-axis';
import makeRef from 'lib/makeRef';

import './completion.scss';

export default class Completion extends React.Component {
  static propTypes = {
    total: propTypes.number,
    value: propTypes.number,
    width: propTypes.number,
    height: propTypes.number,
    className: propTypes.string
  };

  componentDidMount() {
    select(this.heightAxisRef).call(this.heightAxis());
  }

  componentDidUpdate() {
    select(this.heightAxisRef).call(this.heightAxis());
  }

  heightScale = () => {
    return scaleLinear()
      .domain([0, this.props.total])
      .range([0, this.props.height]);
  };

  heightAxis = () => {
    return axisLeft()
      .scale(this.heightScale())
      .tickSize(this.props.width * -1, 0, 0) // draws horizontal "tick" lines in graph
      .tickFormat('') // removes the axis labels for each tick
      .ticks(5);
  };

  makeRef = makeRef.bind(this);

  /**
   * We are only drawing a single rectangle - the data "bind" that would normally happen
   * is just a single CompletionRectangle component being placed in the JSX.
   */
  render() {
    return (
      <div className={classnames('completion-graph', this.props.className)}>
        <svg className='graph' width={this.props.width} height={this.props.height}>
          <g className='bar'>
            <CompletionRectangle
              width={this.props.width}
              y={this.props.height - this.heightScale()(this.props.value)}
              height={this.heightScale()(this.props.value)}
            />
          </g>
          <g className='y axis' ref={this.makeRef} data-ref-name='heightAxisRef' />
        </svg>
      </div>
    );
  }
}

class CompletionRectangle extends React.Component {
  static propTypes = {
    width: propTypes.number.isRequired,
    height: propTypes.number.isRequired,
    y: propTypes.number.isRequired
  };

  render() {
    return (
      <rect className='rect' width={this.props.width} height={this.props.height} y={this.props.y} />
    );
  }
}
